import { Tune } from '@mui/icons-material';
import {
  Alert,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import { Fragment } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useNotificationsPreferencesCard } from '~/scenes/PortalModules/User/UserSettings/components/NotificationPreferencesCard/useNotificationsPreferencesCard';
import { UserSettingsCard } from '~/scenes/PortalModules/User/UserSettings/components/UserSettingsCard';

export const NotificationPreferencesCard = () => {
  const { t } = useTranslation();

  const {
    isEnabled,
    isLoading,
    failedToLoad,
    editMode,
    areas,
    form: {
      control,
      formState: { isDirty },
    },
    onEdit,
    onSubmit,
    onCancelEdit,
    getAreaName,
  } = useNotificationsPreferencesCard();

  if (!isEnabled) {
    return null;
  }

  return (
    <UserSettingsCard
      Icon={Tune}
      title={t('notificationArea')}
      loading={isLoading}
      error={
        failedToLoad ? (
          <Alert severity={'error'}>{t('notificationPreferencesError')}</Alert>
        ) : undefined
      }
      actions={
        editMode ? (
          <>
            <Button onClick={onCancelEdit} size={'small'}>
              {t('laCancel')}
            </Button>
            <Button
              onClick={onSubmit}
              disabled={!isDirty}
              variant={'contained'}
              size={'small'}
            >
              {t('laSave')}
            </Button>
          </>
        ) : (
          <Button onClick={onEdit} size={'small'}>
            {t('laEdit')}
          </Button>
        )
      }
    >
      <FormGroup>
        {areas.map((area) => {
          return (
            <Fragment key={`area_${area}`}>
              <Controller
                control={control}
                name={area}
                render={({ field: { value, onChange } }) => {
                  return (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={!value}
                          onChange={() => onChange(!value)}
                          size={'small'}
                        />
                      }
                      label={getAreaName(area)}
                      disabled={!editMode}
                    />
                  );
                }}
              />
            </Fragment>
          );
        })}
      </FormGroup>
    </UserSettingsCard>
  );
};
